module.exports = __webpack_public_path__ + "img/6.e3cf7ce2.jpg";